import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ArchiveVersion } from '../../models/ArchiveVersion';
import { GraphqlService } from '../../services/graphql.service';
import { Router } from '@angular/router';
import { CommonDataService } from '../../services/common-data.service';

@Component({
  selector: 'app-archive',
  templateUrl: './archive.component.html'
})
export class ArchiveComponent implements OnInit {

  @Output() myEvent = new EventEmitter<string>();
  constructor(private graphQlService: GraphqlService, private router: Router, private commonDataService: CommonDataService) {
  }

  ngOnInit(): void {
    //this.commonDataService.showLoader.next(true);
    this.getArchiveLabel();
  }
  versions: any;
  getVersion() {
    this.versions = [
      { "date": "Current", "version": "27.0" },
      { "date": "08/17/2020 17: 07: 41", "version": "26.0" },
      { "date": "08/17/2019 17: 07: 41", "version": "25.0" },
      { "date": "08/17/2018 17: 07: 41", "version": "24.0" },
      { "date": "08/17/2017 17: 07: 41", "version": "23.0" },
      { "date": "08/17/2016 17: 07: 41", "version": "22.0" },
      { "date": "08/17/2015 17: 07: 41", "version": "21.0" },
      { "date": "08/17/2014 17: 07: 41", "version": "20.0" }
    ];
  }
  archive_header: string = "";
  archive_body: string = "";
  archive_note: string = "";
  archive_general: string = "";
  archive_version: string = "";
  archive_supersededOn: string = "";
  getArchiveLabel() {
    this.getVersion();
    this.graphQlService.GetArchiveLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.archive_header = labels.filter(x => x.key == "archive_header").map(y => y.value);
        this.archive_body = labels.filter(x => x.key == "archive_body").map(y => y.value);
        this.archive_note = labels.filter(x => x.key == "archive_note").map(y => y.value);
        this.archive_general = labels.filter(x => x.key == "archive_general").map(y => y.value);
        this.archive_version = labels.filter(x => x.key == "archive_version").map(y => y.value);
        this.archive_supersededOn = labels.filter(x => x.key == "archive_supersededOn").map(y => y.value);
        //this.commonDataService.showLoader.next(false);
      }
    });
  }

  GoToVersion(version) {
    let pageUrl = this.router.url;
    let publicationId = pageUrl.split("/")[1];
    let pageId = pageUrl.split("/")[2];
    if (version.date != "Current") {
      this.router.navigateByUrl("/archiveContent")
      let archiveVersion: ArchiveVersion = { date: version.date, version: version.version, publicationId: publicationId, pageId: pageId, url: pageUrl };
      this.graphQlService.SetArchiveVersionSession(archiveVersion).subscribe(() => {
        this.commonDataService.archiveContentPage.next(true);
        this.myEvent.emit();
      });
    }
    else {
      this.myEvent.emit();
    }
  }
}
